"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auctionStatus = exports.logStatus = exports.seizeStatus = exports.executeStatus = exports.confirmCollectionType = exports.mediateStatus = exports.hearStatus = void 0;
const ComplexSelect_1 = __importDefault(require("@/class/ComplexSelect"));
const complex_data_1 = require("complex-data");
const litigation_1 = __importDefault(require("../api/litigation"));
const type_1 = require("./type");
exports.hearStatus = new complex_data_1.SelectList({
    name: '审理状态',
    list: [
        {
            value: '1',
            label: '一审',
        },
        {
            value: '2',
            label: '二审',
        }
    ]
});
exports.mediateStatus = new complex_data_1.SelectList({
    name: '调解状态',
    list: [
        {
            value: '1',
            label: '调解中',
        },
        {
            value: '2',
            label: '成功',
        },
        {
            value: '3',
            label: '失败',
        }
    ]
});
exports.confirmCollectionType = new complex_data_1.SelectList({
    name: '确认收款状态',
    list: [
        {
            value: '1',
            label: '未收款',
        },
        {
            value: '2',
            label: '已确认',
        },
        {
            value: '3',
            label: '已核销',
        }
    ]
});
exports.executeStatus = new type_1.SelectListWithRelation({
    name: '执行状态',
    miss: {
        value: undefined,
        label: '完成'
    },
    list: [
        {
            value: 'ufo_cs_zx_10',
            label: '发起执行',
        },
        {
            value: 'ufo_cs_zx_20',
            label: '申请冻结',
        },
        {
            value: 'ufo_cs_zx_30',
            label: '审批冻结',
        },
        {
            value: 'ufo_cs_zx_40',
            label: '执行冻结',
        },
        {
            value: 'ufo_cs_zx_50',
            label: '申请解除冻结',
        },
        {
            value: 'ufo_cs_zx_60',
            label: '审批解除冻结',
        },
        {
            value: 'ufo_cs_zx_70',
            label: '解除冻结',
        },
    ]
});
exports.seizeStatus = new type_1.SelectListWithRelation({
    name: '查封状态',
    miss: {
        value: undefined,
        label: '完成'
    },
    list: [
        {
            value: 'ufo_cs_cf_10',
            label: '发起查封',
        },
        {
            value: 'ufo_cs_cf_20',
            label: '申请查封',
        },
        {
            value: 'ufo_cs_cf_30',
            label: '审批查封',
        },
        {
            value: 'ufo_cs_cf_40',
            label: '执行查封',
        },
        {
            value: 'ufo_cs_cf_50',
            label: '申请解封',
        },
        {
            value: 'ufo_cs_cf_60',
            label: '审批解封',
        },
        {
            value: 'ufo_cs_cf_70',
            label: '解除查封',
        },
    ]
});
class LogStatusSelectList extends complex_data_1.SelectList {
    getNext(process) {
        if (!process) {
            return this.list[0];
        }
        for (let i = 0; i < this.list.length; i++) {
            const item = this.list[i];
            if (item.process > process) {
                return item;
            }
        }
        return undefined;
    }
}
exports.logStatus = new LogStatusSelectList({
    name: '诉讼记录状态',
    list: [
        {
            value: '10',
            label: '申请',
            process: 10
        },
        {
            value: '20',
            label: '立案审批通过',
            process: 20
        },
        {
            value: '30',
            label: '正式立案',
            process: 30
        },
        {
            value: '40',
            label: '开庭',
            process: 40
        },
        {
            value: '50',
            label: '判决',
            process: 50
        },
        {
            value: '60',
            label: '执行立案',
            process: 60,
            auto: true
        },
        {
            value: '70',
            label: '查封冻结',
            process: 70,
            auto: true
        },
        {
            value: '80',
            label: '评估',
            process: 80,
            auto: true
        },
        {
            value: '90',
            label: '拍卖',
            process: 90,
            auto: true
        },
        {
            value: '100',
            label: '结案',
            process: 100,
            auto: true
        },
    ]
});
exports.auctionStatus = new ComplexSelect_1.default({
    name: '法拍状态',
    list: [],
    getData() {
        return new Promise((resolve, reject) => {
            litigation_1.default.litigationAuctionDict.require().then(res => {
                const list = res.data.data.map((item) => {
                    return {
                        value: item.key,
                        label: item.value
                    };
                });
                resolve({ status: 'success', list: list });
            }).catch(err => {
                reject(err);
            });
        });
    }
});
